import styled from 'styled-components'
// themes
import { colors } from 'themes/index'

export const LabelWrapper = styled('div')`
  display: flex;
  color: ${colors.gray400};
  margin-bottom: -12px;
  margin-left: 2px;
  font-size: 14px;

  div:nth-child(1) {
    flex: 1;
  }

  div:nth-child(2) {
    flex: 0.6;
  }
`
